// import React, { useContext, useReducer, useRef, useState } from "react";
// /// Scroll
// import PerfectScrollbar from "react-perfect-scrollbar";
// import { Collapse } from "react-bootstrap";
// /// Link
// import { Link } from "react-router-dom";
// import { MenuList } from "./Menu";
// import { useScrollPosition } from "@n8tb1t/use-scroll-position";
// import { ThemeContext } from "../../../context/ThemeContext";


// const reducer = (previousState, updatedState) => ({
//   ...previousState,
//   ...updatedState,
// });

// const initialState = {
//   active: "",
//   activeSubmenu: "",
// };

// const SideBar = () => {
//   var d = new Date();
//   const [heartBlast, setHeartBlast] = useState(false);
 

//   function handleClick() {
//     setHeartBlast(!heartBlast);
//   }

//   const {
//     iconHover,
//     sidebarposition,
//     headerposition,
//     sidebarLayout,
//     ChangeIconSidebar,
//   } = useContext(ThemeContext);

//   const [state, setState] = useReducer(reducer, initialState);

//   // let handleheartBlast = document.querySelector('.heart');
//   // function heartBlast(){
//   //   return handleheartBlast.classList.toggle("heart-blast");
//   // }



  
//     const handleMouseEnter = () => {
//     ChangeIconSidebar(true);
//     document.body.style.overflow = "hidden"; // lock main page scroll
//   };
//   const handleMouseLeave = () => {
//     ChangeIconSidebar(false);
//     document.body.style.overflow = "auto"; // restore scroll
//   };

//   const [hideOnScroll, setHideOnScroll] = useState(true);
//   useScrollPosition(
//     ({ prevPos, currPos }) => {
//       const isShow = currPos.y > prevPos.y;
//       if (isShow !== hideOnScroll) setHideOnScroll(isShow);
//     },
//     [hideOnScroll]
//   );

//   const handleMenuActive = (status) => {
//     setState({ active: status });
//     if (state.active === status) {
//       setState({ active: "" });
//     }
//   };
//   const handleSubmenuActive = (status) => {
//     setState({ activeSubmenu: status });
//     if (state.activeSubmenu === status) {
//       setState({ activeSubmenu: "" });
//     }
//   };
//   // Menu dropdown list End

//   /// Path
//   let path = window.location.pathname;
//   path = path.split("/");
//   path = path[path.length - 1];

//   return (
//     <div   >
//       <div 
//         // onMouseEnter={() => ChangeIconSidebar(true)}
//         // onMouseLeave={() => ChangeIconSidebar(false)}
//           onMouseEnter={handleMouseEnter}
//         onMouseLeave={handleMouseLeave}
//         className={`deznav  border-right ${iconHover} ${
//           sidebarposition.value === "fixed" &&
//           sidebarLayout.value === "horizontal" &&
//           headerposition.value === "static"
//             ? hideOnScroll > 120
//               ? "fixed"
//               : ""
//             : ""
//         }`}
//       >
//         <PerfectScrollbar  className="deznav-scroll sidebar">
//           <ul className="metismenu "  id="menu">
//             {MenuList?.map((data, index) => {
//               let menuClass = data.classsChange;
//               if (menuClass === "menu-title") {
//                 return (
//                   <li  className={menuClass } key={index}>
//                     {data.title}
//                   </li>
//                 );
//               } else {
//                 return (
//                   <li
//                     className={` ${
//                       state.active === data.title ? "mm-active" : ""
//                     }`}
//                     key={index}
//                   >
//                     {data.content && data.content.length > 0 ? (
//                       <>
//                         <Link
//                           to={"#"}
//                           className="has-arrow"
//                           onClick={() => {
//                             handleMenuActive(data.title);
//                           }}
//                         >
//                           {data.iconStyle}
//                           <span className="nav-text">{data.title}</span>
//                         </Link>
//                         <Collapse
//                           in={state.active === data.title ? true : false}
//                         >
//                           <ul
//                             className={`${
//                               menuClass === "mm-collapse" ? "mm-show" : ""
//                             }`}
//                           >
//                             {data.content &&
//                               data.content.map((data, index) => {
//                                 return (
//                                   <li
//                                     key={index}
//                                     className={`${
//                                       state.activeSubmenu === data.title
//                                         ? "mm-active"
//                                         : ""
//                                     }`}
//                                   >
//                                     {data.content && data.content.length > 0 ? (
//                                       <>
//                                         <Link
//                                           to={data.to}
//                                           className={
//                                             data.hasMenu ? "has-arrow" : ""
//                                           }
//                                           onClick={() => {
//                                             handleSubmenuActive(data.title);
//                                           }}
//                                         >
//                                           {data.title}
//                                         </Link>
//                                         <Collapse
//                                           in={
//                                             state.activeSubmenu === data.title
//                                               ? true
//                                               : false
//                                           }
//                                         >
//                                           <ul
//                                             className={`${
//                                               menuClass === "mm-collapse"
//                                                 ? "mm-show"
//                                                 : ""
//                                             }`}
//                                           >
//                                             {data.content &&
//                                               data.content.map(
//                                                 (data, index) => {
//                                                   return (
//                                                     <>
//                                                       <li key={index}>
//                                                         <Link
//                                                           className={`${
//                                                             path === data.to
//                                                               ? "mm-active"
//                                                               : ""
//                                                           }`}
//                                                           to={data.to}
//                                                         >
//                                                           {data.title}
//                                                         </Link>
//                                                       </li>
//                                                     </>
//                                                   );
//                                                 }
//                                               )}
//                                           </ul>
//                                         </Collapse>
//                                       </>
//                                     ) : (
//                                       <Link to={data.to}>{data.title}</Link>
//                                     )}
//                                   </li>
//                                 );
//                               })}
//                           </ul>
//                         </Collapse>
//                       </>
//                     ) : (
//                       <Link
//                         to={data.to}
//                         onClick={() => {
//                           handleMenuActive(data.title);
//                         }}
//                       >
//                         {data.iconStyle}
//                         <span className="nav-text" style={{color:"black"}}>{data?.title}</span>
//                       </Link>
//                     )}
//                   </li>
//                 );
//               }
//             })}
//           </ul>
      
//         </PerfectScrollbar>
//       </div>
//     </div>
//   );
// };

// export default SideBar;







import React, { useContext, useReducer, useState } from "react";
/// Scroll
import PerfectScrollbar from "react-perfect-scrollbar";
import { Collapse } from "react-bootstrap";
/// Link
import { Link } from "react-router-dom";
import { MenuList } from "./Menu"; // Adjust path if needed
import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import { ThemeContext } from "../../../context/ThemeContext";

const reducer = (previousState, updatedState) => ({
  ...previousState,
  ...updatedState,
});

const initialState = {
  active: "",
  activeSubmenu: "",
};

const SideBar = () => {
  const [heartBlast, setHeartBlast] = useState(false);

  const {
    iconHover,
    sidebarposition,
    headerposition,
    sidebarLayout,
    ChangeIconSidebar,
  } = useContext(ThemeContext);

  const [state, setState] = useReducer(reducer, initialState);

  const handleMouseEnter = () => {
    ChangeIconSidebar(true);
    document.body.style.overflow = "hidden"; // lock main page scroll
  };
  const handleMouseLeave = () => {
    ChangeIconSidebar(false);
    document.body.style.overflow = "auto"; // restore scroll
  };

  const [hideOnScroll, setHideOnScroll] = useState(true);
  useScrollPosition(
    ({ prevPos, currPos }) => {
      const isShow = currPos.y > prevPos.y;
      if (isShow !== hideOnScroll) setHideOnScroll(isShow);
    },
    [hideOnScroll]
  );

  const handleMenuActive = (status) => {
    setState({ active: status });
    if (state.active === status) {
      setState({ active: "" });
    }
  };
  const handleSubmenuActive = (status) => {
    setState({ activeSubmenu: status });
    if (state.activeSubmenu === status) {
      setState({ activeSubmenu: "" });
    }
  };

  /// Path
  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];

  // We add this to easily target the submenu links for hover effects
  const customStyles = `
    .custom-sub-link {
      transition: all 0.3s ease;
    }
    .custom-sub-link:hover {
      color:  #64CAE5 !important;
    }
  `;

  return (
    <div>
      {/* Injecting the custom hover styles here */}
      <style>{customStyles}</style>
      
      <div
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        className={`deznav border-right ${iconHover} ${
          sidebarposition.value === "fixed" &&
          sidebarLayout.value === "horizontal" &&
          headerposition.value === "static"
            ? hideOnScroll > 120
              ? "fixed"
              : ""
            : ""
        }`}
      >
        <PerfectScrollbar className="deznav-scroll sidebar">
          <ul className="metismenu " id="menu">
            {MenuList?.map((data, index) => {
              let menuClass = data.classsChange;
              if (menuClass === "menu-title") {
                return (
                  <li className={menuClass} key={index}>
                    {data.title}
                  </li>
                );
              } else {
                return (
                  <li
                    className={` ${
                      state.active === data.title ? "mm-active" : ""
                    }`}
                    key={index}
                  >
                    {data.content && data.content.length > 0 ? (
                      <>
                        <Link
                          to={"#"}
                          className="has-arrow"
                          onClick={() => {
                            handleMenuActive(data.title);
                          }}
                        >
                          {data.iconStyle}
                          {/* 1. Added style={{color:"black"}} here to make "Legal" dark */}
                          <span className="nav-text" style={{ color: "black" }}>
                            {data.title}
                          </span>
                        </Link>
                        <Collapse
                          in={state.active === data.title ? true : false}
                        >
                          <ul
                            className={`${
                              menuClass === "mm-collapse" ? "mm-show" : ""
                            }`}
                          >
                            {data.content &&
                              data.content.map((subData, subIndex) => {
                                return (
                                  <li
                                    key={subIndex}
                                    className={`${
                                      state.activeSubmenu === subData.title
                                        ? "mm-active"
                                        : ""
                                    }`}
                                  >
                                    {subData.content && subData.content.length > 0 ? (
                                      <>
                                        {/* Nested Dropdown Logic (if you ever use it) */}
                                      </>
                                    ) : (
                                      <Link 
                                        to={subData.to}
                                        /* 2. Added custom class and dynamic inline color for active state */
                                        className={`custom-sub-link ${path === subData.to.replace("/", "") ? "mm-active" : ""}`}
                                        style={{ color: path === subData.to.replace("/", "") ? " #64CAE5" : "" }}
                                      >
                                        {subData.title}
                                      </Link>
                                    )}
                                  </li>
                                );
                              })}
                          </ul>
                        </Collapse>
                      </>
                    ) : (
                      <Link
                        to={data.to}
                        onClick={() => {
                          handleMenuActive(data.title);
                        }}
                      >
                        {data.iconStyle}
                        <span className="nav-text" style={{ color: "black" }}>
                          {data?.title}
                        </span>
                      </Link>
                    )}
                  </li>
                );
              }
            })}
          </ul>
        </PerfectScrollbar>
      </div>
    </div>
  );
};

export default SideBar;
